import { QueryCache } from 'react-query';

const queryCache = new QueryCache();
export default queryCache;
